import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Pipe({
  pure: false,
  name: 'localizedDate',
  standalone: false
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(private datePipe: DatePipe, private translate: TranslateService) {
  }

  public transform(
    value: Date | string | number | undefined | null,
    format: 'short' | 'medium' | 'long' | 'full' | 'shortDate' | 'mediumDate' | 'longDate' | 'fullDate' | 'shortTime' | 'mediumTime' | 'longTime' | 'fullTime' | string
  ): string | null {
    return this.datePipe.transform(value, format, undefined, this.translate.currentLang() ?? undefined);
  }

}
